export default __webpack_public_path__ + "static/media/outline_receipt_long_white_24dp 1.27c01f8c.svg";